// extracted by mini-css-extract-plugin
export default {"sub_nav":"SubNav_sub_nav__-dkft"};